import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import ServiceOverviewSection from "./components/ServiceOverviewSection";
import ChallengesSection from "./components/ChallengesSection";
import AboutSection from "./components/AboutSection";
import ImplementationSupportSection from "./components/ImplementationSupportSection";
import ImplementationFlowSection from "./components/ImplementationFlowSection";
import ImplementationScheduleSection from "./components/ImplementationScheduleSection";
import DeliverablesSection from "./components/DeliverablesSection";
import ExamplesSection from "./components/ExamplesSection";
import ScopeSection from "./components/ScopeSection";
import PricingSection from "./components/PricingSection";
import WhoItIsForSection from "./components/WhoItIsForSection";
import ServiceGuideSection from "./components/ServiceGuideSection";
import FAQSection from "./components/FAQSection";
import RelatedServicesSection from "./components/RelatedServicesSection";
import CTASection from "./components/CTASection";

export default function AiDigitalPage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <ServiceOverviewSection />
      <ChallengesSection />
      <AboutSection />
      <ImplementationSupportSection />
      <ImplementationFlowSection />
      <ImplementationScheduleSection />
      <DeliverablesSection />
      <ExamplesSection />
      <ScopeSection />
      <PricingSection />
      <WhoItIsForSection />
      <ServiceGuideSection />
      <FAQSection />
      <RelatedServicesSection />
      <CTASection />
    </>
  );
}